module.exports = __webpack_public_path__ + "assets/icon-private-message.b3b5d632.svg";